module.exports = __webpack_public_path__ + "static/media/SellerboxGuideProduct.4228c6ee.png";